<template>

  <ul class="menu">
    <li><a :class="menuclass()">{{xtitle}}</a>
      <ul class="dropdown" :style="getstyle()" >  
        <li v-for="(x,key) in items" @click="select(x)" :key="key" :class="getlineclass(x.des)">
          {{getdes(x)}}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { Dau, bus } from "@store/dau"
export default {
  props: {
    items:Array,
    title: {type:String,default:"menu"},
    cod: {type:String,default:"cod"},
    dark:Boolean,
    width: {type:String,default:''},
    selected:Boolean,
  },

  data() {
     return {
        open:false         
     }
  },
  computed: {
     xtitle() {
        if (this.items && this.items.length>0) {
            return Dau.T(this.title)+" "+(this.open?"▴":"▾");
        } else {
          return Dau.T(this.title)
        }
        
     }
  },
  created() {
      document.addEventListener('click',this.onclick);
      document.addEventListener('touchstart',this.onclick);
  },
  beforeDestroy() {
      document.removeEventListener('click',this.onclick);
      document.removeEventListener('touchstart',this.onclick);
  },
  methods: {
      onclick(e) {
      if (e.srcElement.classList[0]=='menu') {
           if (e.srcElement.parentNode.parentNode===this.$el || e.srcElement.parentNode===this.$el || e.srcElement===this.$el) {
               if (this.items && this.items.length>0) {
                 this.open=true;
               } else {
                 this.select({des:this.title,cod:this.cod});
               }
           } else {
               this.open=false;
           }
           this.$forceUpdate();
      } else if (this.open) {
           this.open=false;  
           this.$forceUpdate();
      }
    },
    doopen() {

    },
    menuclass() {
      var a= this.dark?"menu menu-dark":"menu menu-white"
      if (this.selected) a=a +" selected"
      return a;
    },
    getstyle() {
      return this.open?{zIndex:10}:{display:"none" }
    },
    getlineclass(e) {
       if (e=="" || e=="-") {
         return "menuseparator";
       }
    },
    getdes(x) {
      return Dau.T(x.des);
    },
    select(x) {
       if (x.des && x.des!='-') {
           this.$emit("select",x);
       }
    },
    openmenu() {
        this.open=!this.open;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dmenu.vue